/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



import { captureExceptions } from 'utils/SentryHelpers'
import ComposeReplyModal from 'components/reply/ComposeReplyModal'

const ComposeReplyModalWrapper = React.createClass({

  render() {
    return (
      <ComposeReplyModal
        {..._.assign({ onClose: this.props.onModalClose, duplicate: this.props.location.query.duplicate }, this.props)} />
    )
  }
})

export default ComposeReplyModalWrapper



// WEBPACK FOOTER //
// ./src/scripts/components/settings/reply/ComposeReplyModalWrapper.js